import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css";

import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";

import Home from "./pages/Home";
import About from "./pages/About";
import WhatWeDo from "./pages/WhatWeDo";
import ProgrammeDetail from "./pages/ProgrammeDetail";
import OurImpact from "./pages/OurImpact";
import Locations from "./pages/Locations";
import Donate from "./pages/Donate";
import ThankYou from "./pages/ThankYou";
import Gallery from "./pages/Gallery";
import Staff from "./pages/Staff";
import Board from "./pages/Board";
import GetInvolved from "./pages/GetInvolved";
import Contact from "./pages/Contact";

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="site-wrapper">
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/what-we-do" element={<WhatWeDo />} />
          <Route path="/what-we-do/:slug" element={<ProgrammeDetail />} />
          <Route path="/our-impact" element={<OurImpact />} />
          <Route path="/where-we-are-located" element={<Locations />} />
          <Route path="/donate" element={<Donate />} />
          <Route path="/thank-you" element={<ThankYou />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/staff" element={<Staff />} />
          <Route path="/board" element={<Board />} />
          <Route path="/get-involved" element={<GetInvolved />} />
          <Route path="/contact" element={<Contact />} />
          {/* Catch-all: redirect to home */}
          <Route path="*" element={<Home />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
